import { securityInvitationsSendPostAsyncSlice } from './post';

export const {
	requestPostSecurityInvitationsSend,
	resetPostSecurityInvitationsSend
} = securityInvitationsSendPostAsyncSlice.asyncActionCreators;
